import {QR} from 'qr-svg';

export const generateQRCode = (urlToGenerate: string) => {    
    if (!urlToGenerate) {
        return '';
    }
    
    return QR(urlToGenerate);
};
